import { useState, useEffect } from "react";

// Kingdom accessibility + experience settings (localStorage-backed, event-synced).
// Designed to be reused by every future Kingdom game — accessibility should be invisible.
const KEY = "gk_kingdom_settings";
export const DEFAULTS = {
  narrationOn: true,
  speed: "normal",       // slow | normal | fast
  subtitles: true,
  sfxOn: true,
  ambientOn: false,
  calmMode: false,        // fewer particles, no camera motion, gentler audio
  reducedMotion: false,
  readingAssist: false,   // larger, spaced, dyslexia-friendly text
  visualClueHelper: true, // gentle glow when a child is still exploring
};

export function getSettings() {
  try { return { ...DEFAULTS, ...JSON.parse(localStorage.getItem(KEY) || "{}") }; }
  catch { return { ...DEFAULTS }; }
}

export function saveSettings(patch) {
  const next = { ...getSettings(), ...patch };
  try { localStorage.setItem(KEY, JSON.stringify(next)); } catch {}
  window.dispatchEvent(new Event("gk-settings"));
  return next;
}

export function useKingdomSettings() {
  const [s, setS] = useState(getSettings);
  useEffect(() => {
    const h = () => setS(getSettings());
    window.addEventListener("gk-settings", h);
    return () => window.removeEventListener("gk-settings", h);
  }, []);
  return [s, (patch) => setS(saveSettings(patch))];
}

export function prefersReducedMotion() {
  const s = getSettings();
  if (s.calmMode || s.reducedMotion) return true;
  try { return window.matchMedia("(prefers-reduced-motion: reduce)").matches; } catch { return false; }
}
